module.exports = __webpack_public_path__ + "img/img_cost_material.6edeb188.jpg";